import React from 'react';
import { CircularProgress, Fab, styled } from '@mui/material';
import { keyframes } from '@emotion/react';
import { Refresh } from '@mui/icons-material';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const FABLabel = styled('span')(({ showLabel }) => ({
  maxWidth: showLabel ? '180px' : '0px',
  opacity: showLabel ? 1 : 0,
  overflow: 'hidden',
  transition: 'max-width 250ms cubic-bezier(0.4, 0, 0.2, 1) 50ms, opacity 200ms ease 100ms',
  marginRight: showLabel ? '8px' : '0px',
  paddingLeft: showLabel ? '16px' : '0px',
  display: 'inline-block',
}));

const RefreshSpinnerButton = ({
  handleOnClick,
  handleOnAnimationEnd = () => {},
  isLoading = false,
  isSpinning = false,
  label = '',
}) => (
  <>
    <Fab
      color="appbar"
      aria-label="refresh"
      sx={{
        width: label ? 'fit-content' : '56px',
        borderRadius: label ? '28px' : '50%',
        paddingRight: label ? '16px' : '0px',
      }}
      onClick={handleOnClick}
    >
      <FABLabel showLabel={!!label}>{label}</FABLabel>
      <Refresh
        sx={{
          animation: isSpinning ? `${spin} 600ms ease-in-out` : 'none',
        }}
        onAnimationEnd={handleOnAnimationEnd}
      />
    </Fab>

    {(isLoading || isSpinning) && !label && (
      <CircularProgress
        size={64}
        sx={{
          position: 'absolute',
          top: -4,
          left: -4,
          zIndex: 1,
          pointerEvents: 'none',
          color: (theme) => theme.palette.appbar?.main ?? theme.palette.primary.main,
        }}
      />
    )}
  </>
);

export default RefreshSpinnerButton;
